import { useState } from "react";
import { Plus } from "lucide-react";
import SectionHeader from "../eventsExperiences/SectionHeader";

const FAQS = [
  {
    q: "How much does an influencer campaign cost?",
    a: "It depends on creator tier, number of creators and content type. Share your budget and goal and we will propose a plan within 24 hours.",
  },
  {
    q: "Can you run a campaign for an event or a launch?",
    a: "Yes. We promote events, launches and brands, and can also manage your Instagram handle alongside the campaign.",
  },
  {
    q: "How do you choose creators?",
    a: "We check audience fit, engagement quality, content style and past brand work before shortlisting.",
  },
  {
    q: "Do I approve the content before it goes live?",
    a: "Always. Every creator post goes through your approval first.",
  },
];

const InfluencerFaq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="ee-section im-faq">
      <div className="container im-faq-inner">
        <SectionHeader eyebrow="FAQs" title="Questions we" accent="hear often." />
        <div className="im-faq-list" data-aos="fade-up" data-aos-once="true">
          {FAQS.map(({ q, a }, i) => {
            const isOpen = open === i;
            return (
              <div className={`im-faq-item${isOpen ? " is-open" : ""}`} key={q}>
                <button
                  type="button"
                  className="im-faq-q"
                  aria-expanded={isOpen}
                  aria-controls={`im-faq-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span>{q}</span>
                  <span className="im-faq-toggle"><Plus size={18} /></span>
                </button>
                <div className="im-faq-a" id={`im-faq-${i}`} role="region">
                  <div>
                    <p>{a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default InfluencerFaq;
